import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Frota } from "../../../model";
import { Observable } from "rxjs";
import { API } from "../../../app.config";

@Injectable({
    providedIn: "root",
})
export class FrotaService {
    constructor(private http: HttpClient) {}

    post(frota: Frota): Observable<Frota> {
        return this.http.post<Frota>(`${API}/api/frotarodoviaria`, frota);
    }

    put(frota: Frota): Observable<Frota> {
        return this.http.put<Frota>(`${API}/api/frotarodoviaria/${frota.Id}`, frota);
    }

    delete(id: number): Observable<any> {
        return this.http.delete<any>(`${API}/api/frotarodoviaria/${id}`);
    }
}
